module.exports = {
	"share": {
		"url": "http://four32c.com/holiday/",
		"title": "Holiday Cheer from FOUR32C!",
		"description": "Check out some of West Chelsea's shops, galleries, eateries, and bars with this handy-dandy guide by FOUR32C!",
		"image": "images/four32c-share.jpg"
	},
	"map": {
		"labels": [
			{
				"icon": "four32c-logo office",
				"x": 401,
				"y": 265
			}
		],
		"streets": [
			{
				"icon": "streets-01",
				"x": 51,
				"y": 255
			},
			{
				"icon": "streets-02",
				"x": 194,
				"y": 108
			},
			{
				"icon": "streets-03",
				"x": 338,
				"y": 64
			},
			{
				"icon": "streets-04",
				"x": 599,
				"y": 195
			},
			{
				"icon": "streets-05",
				"x": 552,
				"y": 366
			},
			{
				"icon": "streets-06",
				"x": 464,
				"y": 499
			},
			{
				"icon": "streets-07",
				"x": 599,
				"y": 710
			}
		],
		"blocks": [
			{
				"icon": "block-01",
				"x": 271,
				"y": 151,
				"fontSize": 34.75
			},
			{
				"icon": "block-02",
				"x": 274,
				"y": 191,
				"fontSize": 29.5
			},
			{
				"icon": "block-03",
				"x": 279,
				"y": 228,
				"fontSize": 29.8
			},
			{
				"icon": "block-04",
				"x": 283,
				"y": 287,
				"fontSize": 70.15
			},
			{
				"icon": "block-05",
				"x": 296,
				"y": 362,
				"fontSize": 63.5
			},
			{
				"icon": "block-06",
				"x": 383,
				"y": 115,
				"fontSize": 28.5
			},
			{
				"icon": "block-07",
				"x": 382,
				"y": 153,
				"fontSize": 31
			},
			{
				"icon": "block-08",
				"x": 383,
				"y": 191,
				"fontSize": 29
			},
			{
				"icon": "block-09",
				"x": 383,
				"y": 229,
				"fontSize": 29
			},
			{
				"icon": "block-10",
				"x": 383,
				"y": 305,
				"fontSize": 34.5
			},
			{
				"icon": "block-11",
				"x": 382,
				"y": 343,
				"fontSize": 25
			},
			{
				"icon": "block-12",
				"x": 382,
				"y": 388,
				"fontSize": 26
			},
			{
				"icon": "block-13",
				"x": 382,
				"y": 427,
				"fontSize": 35.6
			},
			{
				"icon": "block-14",
				"x": 389,
				"y": 464,
				"fontSize": 26.75
			},
			{
				"icon": "block-15",
				"x": 393,
				"y": 499,
				"fontSize": 30
			},
			{
				"icon": "block-16",
				"x": 401,
				"y": 536,
				"fontSize": 29.78
			},
			{
				"icon": "block-17",
				"x": 412,
				"y": 573,
				"fontSize": 26.5
			},
			{
				"icon": "block-18",
				"x": 431,
				"y": 609,
				"fontSize": 29
			},
			{
				"icon": "block-19",
				"x": 438,
				"y": 647,
				"fontSize": 30
			},
			{
				"icon": "block-20",
				"x": 444,
				"y": 687,
				"fontSize": 32
			},
			{
				"icon": "block-21",
				"x": 441,
				"y": 114,
				"fontSize": 28
			},
			{
				"icon": "block-22",
				"x": 439,
				"y": 152,
				"fontSize": 31
			},
			{
				"icon": "block-23",
				"x": 440,
				"y": 191,
				"fontSize": 29.6
			},
			{
				"icon": "block-24",
				"x": 440,
				"y": 229,
				"fontSize": 29
			},
			{
				"icon": "block-25",
				"x": 441,
				"y": 305,
				"fontSize": 33.7
			},
			{
				"icon": "block-26",
				"x": 441,
				"y": 342,
				"fontSize": 25
			},
			{
				"icon": "block-27",
				"x": 443,
				"y": 388,
				"fontSize": 25
			},
			{
				"icon": "block-28",
				"x": 441,
				"y": 427,
				"fontSize": 35
			},
			{
				"icon": "block-29",
				"x": 440,
				"y": 464,
				"fontSize": 26
			},
			{
				"icon": "block-30",
				"x": 441,
				"y": 499,
				"fontSize": 30
			},
			{
				"icon": "block-31",
				"x": 440,
				"y": 536,
				"fontSize": 29
			},
			{
				"icon": "block-32",
				"x": 439,
				"y": 573,
				"fontSize": 26
			},
			{
				"icon": "block-33",
				"x": 532,
				"y": 211,
				"fontSize": 68.95
			},
			{
				"icon": "block-34",
				"x": 519,
				"y": 228,
				"fontSize": 32.5
			},
			{
				"icon": "block-35",
				"x": 533,
				"y": 267,
				"fontSize": 32
			},
			{
				"icon": "block-36",
				"x": 534,
				"y": 307,
				"fontSize": 35
			},
			{
				"icon": "block-37",
				"x": 532,
				"y": 344,
				"fontSize": 27.87
			},
			{
				"icon": "block-38",
				"x": 533,
				"y": 389,
				"fontSize": 28.3
			},
			{
				"icon": "block-39",
				"x": 532,
				"y": 428,
				"fontSize": 38.3
			},
			{
				"icon": "block-40",
				"x": 532,
				"y": 464,
				"fontSize": 26.2
			},
			{
				"icon": "block-41",
				"x": 528,
				"y": 499,
				"fontSize": 29.6
			},
			{
				"icon": "block-42",
				"x": 532,
				"y": 537,
				"fontSize": 28
			},
			{
				"icon": "block-43",
				"x": 531,
				"y": 572,
				"fontSize": 28.49
			},
			{
				"icon": "block-44",
				"x": 534,
				"y": 608,
				"fontSize": 30
			},
			{
				"icon": "block-45",
				"x": 532,
				"y": 647,
				"fontSize": 30.36
			},
			{
				"icon": "block-46",
				"x": 531.8,
				"y": 685,
				"fontSize": 28.4
			},
			{
				"icon": "block-47",
				"x": 481,
				"y": 732,
				"fontSize": 23.5
			},
			{
				"icon": "block-48",
				"x": 502,
				"y": 733,
				"fontSize": 23.6
			},
			{
				"icon": "block-49",
				"x": 557,
				"y": 733,
				"fontSize": 23.7
			},
			{
				"icon": "block-50",
				"x": 486,
				"y": 770,
				"fontSize": 33.78
			},
			{
				"icon": "block-51",
				"x": 507,
				"y": 770,
				"fontSize": 33.76
			},
			{
				"icon": "block-52",
				"x": 557,
				"y": 770,
				"fontSize": 34
			},
			{
				"icon": "block-53",
				"x": 500,
				"y": 840,
				"fontSize": 91
			},
			{
				"icon": "block-54",
				"x": 526,
				"y": 821,
				"fontSize": 52
			},
			{
				"icon": "block-55",
				"x": 558,
				"y": 816,
				"fontSize": 40
			}
		],
		"numbers": [
			{
				"icon": "number-01",
				"x": 358,
				"y": 190
			},
			{
				"icon": "number-02",
				"x": 433,
				"y": 346
			},
			{
				"icon": "number-03",
				"x": 486,
				"y": 463
			},
			{
				"icon": "number-04",
				"x": 278,
				"y": 227
			},
			{
				"icon": "number-05",
				"x": 494,
				"y": 315
			},
			{
				"icon": "number-06",
				"x": 440,
				"y": 463
			},
			{
				"icon": "number-07",
				"x": 488,
				"y": 299
			},
			{
				"icon": "number-08",
				"x": 484,
				"y": 505
			},
			{
				"icon": "number-09",
				"x": 519,
				"y": 648
			},
			{
				"icon": "number-10",
				"x": 442,
				"y": 388
			},
			{
				"icon": "number-11",
				"x": 308,
				"y": 190
			},
			{
				"icon": "number-12",
				"x": 446,
				"y": 337
			},
			{
				"icon": "number-13",
				"x": 490,
				"y": 427
			},
			{
				"icon": "number-14",
				"x": 439,
				"y": 426
			},
			{
				"icon": "number-15",
				"x": 494,
				"y": 492
			},
			{
				"icon": "number-16",
				"x": 491,
				"y": 647
			},
			{
				"icon": "number-17",
				"x": 405,
				"y": 342
			},
			{
				"icon": "number-18",
				"x": 307,
				"y": 265
			},
			{
				"icon": "number-19",
				"x": 404,
				"y": 305
			},
			{
				"icon": "number-20",
				"x": 422,
				"y": 85
			},
			{
				"icon": "number-21",
				"x": 401,
				"y": 536
			},
			{
				"icon": "number-22",
				"x": 377,
				"y": 463
			},
			{
				"icon": "number-23",
				"x": 490,
				"y": 571
			},
			{
				"icon": "number-24",
				"x": 499,
				"y": 832
			}
		],
		"extras": [
			{
				"icon": "harbor",
				"x": 290,
				"y": 447
			}
		]
	},
	"quiz": {
		"questions": [
			{
				"id": 0,
				"title": "What's your fancy?",
				"answers": [
					{
						"label": "Have a drink",
						"href": "/quiz/question/1",
						"data": {}
					},
					{
						"label": "Grab a nosh",
						"href": "/quiz/question/2",
						"data": {}
					},
					{
						"label": "Shop 'til you drop",
						"href": "/quiz/question/3",
						"data": {}
					},
					{
						"label": "See some art",
						"href": "/quiz/question/4",
						"data": {}
					}
				]
			},
			{
				"id": 1,
				"title": "What sounds good?",
				"answers": [
					{
						"label": "Leather bar swill",
						"href": "/map/1"
					},
					{
						"label": "A fancy cuppa Joe",
						"href": "/map/3"
					},
					{
						"label": "Hand-crafted treats and drinks",
						"href": "/map/4"
					},
					{
						"label": "No-frills brew",
						"href": "/map/2"
					},
					{
						"label": "A taste of Switzerland",
						"href": "/map/5"
					},
					{
						"label": "Something small and toasty",
						"href": "/map/6"
					}
				]
			},
			{
				"id": 2,
				"title": "What sounds good?",
				"answers": [
					{
						"label": "Something to go",
						"href": "/map/7"
					},
					{
						"label": "See and be scene",
						"href": "/map/8"
					},
					{
						"label": "Breakfast for lunch, lunch for dinner",
						"href": "/map/9"
					},
					{
						"label": "Japanese comfort food",
						"href": "/map/10"
					},
					{
						"label": "A little (big) Southern charm",
						"href": "/map/11"
					},
					{
						"label": "Mmmm ... burgers",
						"href": "/map/12"
					}
				]
			},
			{
				"id": 3,
				"title": "What sounds good?",
				"answers": [
					{
						"label": "Get your smart on",
						"href": "/map/13"
					},
					{
						"label": "Indulge your inner fashionista",
						"href": "/map/14"
					},
					{
						"label": "Fancy-schmancy wines",
						"href": "/map/15"
					},
					{
						"label": "Kitchen tools of the trade",
						"href": "/map/16"
					},
					{
						"label": "One-of-a-kind objets d'art",
						"href": "/map/17"
					},
					{
						"label": "Artsy-fartsy publications",
						"href": "/map/18"
					}
				]
			},
			{
				"id": 4,
				"title": "What sounds good?",
				"answers": [
					{
						"label": "Superstars",
						"href": "/map/19"
					},
					{
						"label": "Minimalists",
						"href": "/map/22"
					},
					{
						"label": "Up-and-comers",
						"href": "/map/23"
					},
					{
						"label": "Environmental art",
						"href": "/map/20"
					},
					{
						"label": "Performance art",
						"href": "/map/21"
					},
					{
						"label": "American classics",
						"href": "/map/24"
					}
				]
			}
		],
		"results": [
			{
				"no": 1,
				"title": "Eagle Bar NYC",
				"url": "http://www.eaglenyc.com",
				"description": "Cheap drinks and hot staff make for a good time at this West Chelsea classic. Leather chaps optional.",
				"address_line1": "554 West 28th Street",
				"address_line2": "New York, NY 10001",
				"tags": "Tags: leather bar, theme nights, dive"
			},
			{
				"no": 3,
				"title": "Intelligentsia Coffee",
				"url": "http://www.intelligentsiacoffee.com/",
				"description": "Bourgeois brew for the stiletto set, based in the posh High Line Hotel. Perfect for people watching.",
				"address_line1": "180 10th Avenue",
				"address_line2": "New York, NY 10011",
				"tags": "Tags: coffee, people watching"
			},
			{
				"no": 4,
				"title": "Martha Stewart Café",
				"url": "http://www.marthastewartcafe.com/",
				"description": "Munch on Martha-approved treats and brews. This grab-and-go café is a good thing.",
				"address_line1": "601 West 26th Street",
				"address_line2": "New York, NY 10001",
				"tags": "Tags: pastries, coffee, tea"
			},
			{
				"no": 2,
				"title": "The Half King",
				"url": "http://www.thehalfking.com/",
				"description": "This solid, no-frills resto-bar features standard pub fare that ain’t half bad.",
				"address_line1": "505 West 23rd Street",
				"address_line2": "New York, NY 10011",
				"tags": "Tags: cold beer, no frills"
			},
			{
				"no": 5,
				"title": "Trestle on Tenth",
				"url": "http://www.trestleontenth.com/",
				"description": "Sample from the excellent wine list or go whole hog with an entire roast pig for your dinner group.",
				"address_line1": "242 10th Avenue",
				"address_line2": "New York, NY 10001",
				"tags": "Tags: a whole pig, neighborhood joint, wine list"
			},
			{
				"no": 6,
				"title": "Underline Coffee",
				"url": "http://underlinecoffee.com/",
				"description": "Tucked under the High Line, this teeny-tiny purveyor of fine coffees features a toast bar. Cuz #toast is trending.",
				"address_line1": "511 West 20th Street",
				"address_line2": "New York, NY 10011",
				"tags": "Tags: cold brews, small eats, #toast"
			},
			{
				"no": 7,
				"title": "Bottino Take Out",
				"url": "http://www.bottinonyc.com/",
				"description": "Get #15 on wheat—not to start a fight, but it’s the Best Sandwich in New York. ",
				"address_line1": "246 10th Avenue",
				"address_line2": "New York, NY 10001",
				"tags": "Tags: sandwiches, salads"
			},
			{
				"no": 8,
				"title": "Cookshop",
				"url": "http://cookshopny.com/",
				"description": "The weekend brunch crowd is hip and young, while the dinner vibe is more relaxed and refined.",
				"address_line1": "156 10th Avenue",
				"address_line2": "New York, NY 10011",
				"tags": "Tags: waiting in line for eggs, brunch scene"
			},
			{
				"no": 9,
				"title": "Friedman’s Lunch",
				"url": "http://www.friedmansrestaurant.com/",
				"description": "Chelsea Market can get pretty darned loud, so order to go and have yourself a picnic on the High Line.",
				"address_line1": "75 9th Avenue",
				"address_line2": "New York, NY 10011",
				"tags": "Tags: good sandwiches"
			},
			{
				"no": 10,
				"title": "Juban",
				"url": "http://www.jubannyc.com/",
				"description": "Think yummy Japanese-inspired tapas with an excellent selection of whiskeys, sake, and shochu.",
				"address_line1": "207 10th Avenue",
				"address_line2": "New York, NY 10011",
				"tags": "Tags: sushi, sake, shochu"
			},
			{
				"no": 11,
				"title": "Porchlight",
				"url": "http://porchlightbar.com/",
				"description": "This spacious bar features a buzzing Southern-style happy hour and Southern-style comfort. ",
				"address_line1": "271 11th Avenue",
				"address_line2": "New York, NY 10001",
				"tags": "Tags: happy hour, off the beaten path"
			},
			{
				"no": 12,
				"title": "The Red Cat",
				"url": "http://www.theredcat.com/",
				"description": "The tasty eats can get pricey, but this cozy bistro serves one of the Best Burgers in the city.",
				"address_line1": "227 10th Avenue",
				"address_line2": "New York, NY 10011",
				"tags": "Tags: charming, top notch"
			},
			{
				"no": 13,
				"title": "192 Books",
				"url": "http://www.192books.com/",
				"description": "This cozy indie bookstore boasts an enthusiastic, knowledgeable staff.",
				"address_line1": "192 10th Avenue",
				"address_line2": "New York, NY 10011",
				"tags": "Tags: smarty pants, literary, books"
			},
			{
				"no": 14,
				"title": "Anthom",
				"url": "https://www.shopanthom.com/",
				"description": "This boutique carries oh-so-New York clothing for women who appreciate unique design and high quality.",
				"address_line1": "197 10th Avenue",
				"address_line2": "New York, NY 10011",
				"tags": "Tags: clothing, boutique"
			},
			{
				"no": 15,
				"title": "Appellation Wine",
				"url": "http://appellationnyc.com/",
				"description": "This neighborhood wine shop focuses on organic and biodynamic wines.",
				"address_line1": "156 10th Avenue",
				"address_line2": "New York, NY 10011",
				"tags": "Tags: wine store, organic, biodynamic"
			},
			{
				"no": 16,
				"title": "Bowery Kitchen Supplies",
				"url": "http://bowerykitchens.com/",
				"description": "This no-nonsense kitchen supply store that stocks everything from giant woks to fish tweezers.",
				"address_line1": "88 10th Avenue",
				"address_line2": "New York, NY 10011",
				"tags": "Tags: kitchen, supplies, provisions"
			},
			{
				"no": 17,
				"title": "Chamber",
				"url": "http://chambernyc.com/",
				"description": "This gallery-cum-art store features limited editions and unique works of art carefully curated by local artists.",
				"address_line1": "515 West 23rd Street",
				"address_line2": "New York, NY 10011",
				"tags": "Tags: artsy fartsy, objects, gifts, boutique"
			},
			{
				"no": 18,
				"title": "Printed Matter",
				"url": "https://printedmatter.org/",
				"description": "The tragically hip staff may roll their eyes, but the primo selection of newest and rarest art books is worth a visit.",
				"address_line1": "231 11th Avenue",
				"address_line2": "New York, NY 10001",
				"tags": "Tags: hipsters, art books, smart pants"
			},
			{
				"no": 19,
				"title": "Gladstone Gallery",
				"url": "http://www.gladstonegallery.com/",
				"description": "It may lack the edge of Brooklyn galleries, but you'll see major works before they are swooped into private collections.",
				"address_line1": "515 West 24th Street",
				"address_line2": "New York institution",
				"tags": "Tags: art world megastars"
			},
			{
				"no": 22,
				"title": "Paula Cooper Gallery",
				"url": "https://www.paulacoopergallery.com/",
				"description": "A mainstay of New York art for over 40 years, Paula Cooper Gallery also hosts dance, music, and readings.",
				"address_line1": "534 West 21st Street",
				"address_line2": "New York, NY 10011",
				"tags": "Tags: minimalism, conceptual art"
			},
			{
				"no": 23,
				"title": "Petzel Gallery",
				"url": "http://www.petzel.com/",
				"description": "A gallery of rising artists. Bring your black AmEx if you want to take anything home.",
				"address_line1": "456 West 18th Street",
				"address_line2": "New York, NY 10011",
				"tags": "Tags: contemporary art, pricey"
			},
			{
				"no": 20,
				"title": "The High Line",
				"url": "http://www.thehighline.org/",
				"description": "This old rail line turned urban oasis attracts tourists and locals alike. ",
				"address_line1": "Gansevoort Street to West 34th Street",
				"address_line2": "New York, NY 10011",
				"tags": "Tags: your family is in town, tourists"
			},
			{
				"no": 21,
				"title": "The Kitchen",
				"url": "http://thekitchen.org/",
				"description": "A longtime hub of the downtown arts scene, the artists range from household names to beyond-experimental.",
				"address_line1": "512 West 19th Street",
				"address_line2": "New York, NY 10011",
				"tags": "Tags: performance art, dance, theater, music"
			},
			{
				"no": 24,
				"title": "Whitney Museum",
				"url": "http://whitney.org/",
				"description": "In a shiny new building, wander the huge collections of 20th century and contemporary American art.",
				"address_line1": "99 Gansevoort Street",
				"address_line2": "New York, NY 10014",
				"tags": "Tags: American art"
			}
		]
	}
};


/*****************
 ** WEBPACK FOOTER
 ** /Users/cdrobish/Development/ChadAndrewDrobish/four32c/holiday-map/development/~/json-loader!./data/map.json
 ** module id = 11
 ** module chunks = 0
 **/